export default {
  "disclaimer-inline": "_disclaimer-inline_182wpo",
  "disclaimer-inline__icon": "_disclaimer-inline__icon_182wpo",
  "error": "_error_182wpo",
  "info": "_info_182wpo",
  "warning": "_warning_182wpo",
  "disclaimer-inline__message": "_disclaimer-inline__message_182wpo"
};